import 'slick-carousel';

const carousel = document.querySelector('.carousel-responsive');

export function carouselResponsive() {
    if (carousel) {
        $('.carousel-responsive').slick({
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: `<button type="button" class="slick-prev slick-arrow" title="Go to prev slide">
			<span><i class="fa fa-chevron-left prev"></i></span>
		</button>`,
            nextArrow: `<button type="button" class="slick-next slick-arrow" title="Go to next slide">
			<span><i class="fa fa-chevron-right next"></i></span>
		</button>`,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });

    }
}
